<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse1"
                    aria-expanded="false" aria-controls="collapse1">
                Vragen vooraf
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse show" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Dit betreft algemene vragen over de onderneming.</p>

                <p>Is er sprake van de aangifte voor een fiscale eenheid? Beantwoord hier dan de vragen op het niveau
                    van de fiscale eenheid.</p>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                Agrarische activiteiten
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Agrarische activiteiten zijn bijvoorbeeld:</p>
                <ul class="bullet-list">
                    <li>akkerbouw.</li>
                    <li>bloembollen- en bloemknollenkwekerij.</li>
                    <li>groentekwekerij.</li>
                    <li>pluimvee- en gevogeltefokkerij.</li>
                    <li>rundvee- en kleinveefokkerij.</li>
                    <li>varkensfokkerij.</li>
                </ul>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading3">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
                Functionele valuta
            </button>
        </h2>
        <div id="collapse3" class="accordion-collapse collapse" aria-labelledby="heading3"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <b>Aangifte doen in een andere valuta dan de euro</b>
                <p>Alleen als je een beschikking 'Regeling functionele valuta' hebt ontvangen, kun je aangifte doen in
                    een andere munteenheid dan de euro (functionele valuta). Je moet de beschikking voor het begin van
                    het boekjaar bij de Belastingdienst hebben aangevraagd.</p>
                <p>Als je een beschikking 'Regeling functionele valuta' hebt ontvangen, ben je verplicht aangifte te
                    doen in de functionele valuta.</p>
                <p>Als je aangifte doet in een andere munteenheid dan de euro, vermeld je in deze aangifte de bedragen
                    in hele geldeenheden in de munteenheid die je hebt gekozen. Je houdt hierbij rekening met de
                    valutafactor die voor deze munteenheid geldt. Als je de munteenheid kiest, dan wordt automatisch de
                    factor die geldt voor die munteenheid getoond. Bedragen in functionele valuta moet u delen door deze
                    factor.</p>
                <div style="border: 1px solid #ccc; padding: 10px; background-color: lightgrey">
                    <p><u>Voorbeeld</u></p>
                    <p>25.000.000 yen geef je aan als 250.000. (De factor van de yen is 100). U mag in uw eigen voordeel
                        afronden.</p>
                </div>
                <b>Let op!</b>
                <p>Het €-teken verandert op dit moment niet als je aangiofte doet in andere valuta.</p>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading4">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse4" aria-expanded="false" aria-controls="collapse4">
                Innovatiebox
            </button>
        </h2>
        <div id="collapse4" class="accordion-collapse collapse" aria-labelledby="heading4"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Je kunt gebruikmaken van de innovatiebox als de vennootschap immateriële activa ontwikkelt
                    (bijvoorbeeld een uitvinding of technische toepassing) en daarvoor een S&O-verklaring heeft
                    gekregen. Als de activa ook voldoen aan een aantal andere voorwaarden, geldt voor opbrengsten uit
                    deze activa een effectieve heffing van 9%.
                    <br/><br/>
                    De innovatiebox geldt niet voor merken, logo's en daarmee vergelijkbare vermogensbestanddelen.</p>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading5">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse5" aria-expanded="false" aria-controls="collapse5">
                Wijziging activiteiten
            </button>
        </h2>
        <div id="collapse5" class="accordion-collapse collapse" aria-labelledby="heading5"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Het gaat hierbij om wijziging van de hoofdactiviteiten en niet van eventuele hulpactiviteiten of
                    afgeleide activiteiten.</p>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading6">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse6" aria-expanded="false" aria-controls="collapse6">
                Wijziging waarderingsstelsel
            </button>
        </h2>
        <div id="collapse6" class="accordion-collapse collapse" aria-labelledby="heading6"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Bij wijzigingen in het waarderingsstelsel van activa en/of passiva gaat het om wijzigingen in
                    balansposten, bijvoorbeeld een wijziging in het systeem van:</p>
                <ul>
                    <li>voorraadwaardering, bijvoorbeeld vervanging van een systeem van waardering op kostprijs of
                        lagere marktwaarde door een ijzerenvoorraadstelsel. Hieronder valt ook een wijziging van de
                        grondslagen van de voorraadwaardering (bijvoorbeeld als de vennootschap bij gebruikmaking van
                        het
                        ijzerenvoorraadstelsel de vaste basisprijs hebt verlaagd of verhoogd).
                    </li>
                    <li>afschrijving, bijvoorbeeld vervanging van een systeem van lineaire afschrijving door een systeem
                        van afschrijving naar boekwaarde, de zogenoemde degressieve afschrijving. Ook hierbij kan het
                        zijn dat de vennootschap de grondslagen van de afschrijving hebt gewijzigd, bijvoorbeeld door
                        wijziging van de
                        hoogte van de restwaarde of de hoogte van het afschrijvingspercentage.
                    </li>
                </ul>
                <b>Let op!</b>
                <p>Een wijziging van het waarderingsstelsel is slechts toegestaan als goed koopmansgebruik dit
                    rechtvaardigt. Ook het nieuwe waarderingsstelsel moet in overeenstemming zijn met goed
                    koopmansgebruik. De stelselwijziging mag niet willekeurig zijn of uitsluitend gericht zijn op het
                    behalen van incidenteel fiscaal voordeel.</p>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading7">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse7" aria-expanded="false" aria-controls="collapse7">
                Willekeurige afschrijving
            </button>
        </h2>
        <div id="collapse7" class="accordion-collapse collapse" aria-labelledby="heading7"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Willekeurig afschrijven wil zeggen dat je in plaats van de gebruikelijke afschrijving zelf bepaalt
                    hoe en wanneer je een bedrijfsmiddel afschrijft. De boekwaarde van het bedrijfsmiddel mag niet lager
                    worden dan de restwaarde.</p>
                <p>Je kunt alleen willekeurig afschrijven als u investeerde in bepaalde
                    milieubedrijfsmiddelen. Zeeschepen komen ook in aanmerking voor willekeurige afschrijving.</p>
                <b>Bedrijfsmiddelen die de economische ontwikkeling bevorderen</b>
                <p>Tot en met 2013 gold een specifieke regeling voor bepaalde bedrijfsmiddelen die de economische
                    ontwikkeling bevorderen. Hebt u destijds geïnvesteerd in deze bedrijfsmiddelen? Zolang de restwaarde
                    niet is bereikt, kun je willekeurig blijven afschrijven.</p>
                <b>Afschrijven vóór ingebruikname</b>
                <p>Bij willekeurige afschrijving is het mogelijk om al af te schrijven op een bedrijfsmiddel vanaf het
                    moment dat de vennootschap verplichtingen is aangegaan of voortbrengingskosten hebt gemaakt. Je kunt
                    echter niet meer afschrijven dan er betaald is.</p>
                <b>Terugnemen willekeurige afschrijving</b>
                <p>Gaat de vennootschap het bedrijfsmiddel waarop willekeurig is afgeschreven verhuren binnen 5 jaar na
                    het begin van het kalenderjaar waarin het de investering deed? Dan moet je de willekeurige
                    afschrijving terugnemen. Je moet dan de boekwaarde van het bedrijfsmiddel aanpassen. Dit geldt niet
                    voor milieubedrijfsmiddelen.</p>
                <p>De boekwaarde bepaal je op basis van de waarde die het bedrijfsmiddel gehad zou hebben als de
                    vennootschap niet
                    willekeurig had afgeschreven. Het aanpassen van de boekwaarde leidt meestal tot een hogere fiscale
                    winst.</p>
                <p>Voor zeeschepen geldt dat je de willekeurige afschrijving moet terugnemen als de vennootschap er
                    binnen 10 jaar voor
                    kiest gebruik te maken van de tonnageregeling.</p>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading8">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse8" aria-expanded="false" aria-controls="collapse8">
                Wijziging pensioenregeling
            </button>
        </h2>
        <div id="collapse8" class="accordion-collapse collapse" aria-labelledby="heading8"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Kies 'Ja' als een bestaande pensioenregeling is gewijzigd, bijvoorbeeld door afkoop, overdracht,
                    inkoop of overname van verplichtingen.</p>
                <p>Let op! Sinds 2017 kun jeniet langer in eigen beheer pensioen opbouwen.Je kunt ook geen bedragen meer
                    toevoegen aan pensioenvoorzieningen die je in eigen beheer hebt gevormd. Je moet nog wel actuarieel
                    oprenten.</p>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading9">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse9" aria-expanded="false" aria-controls="collapse9">
                Wijziging verdeling aandelenkapitaal
            </button>
        </h2>
        <div id="collapse9" class="accordion-collapse collapse" aria-labelledby="heading9"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <b>Middellijke en onmiddellijke aandeelhouders</b>
                <p> Een onmiddellijke aandeelhouder is een directe aandeelhouder. Met middellijk aandeelhouderschap
                    wordt bedoeld dat een vennootschap of een natuurlijk persoon die niet rechtstreeks aandelen aanhoudt
                    in een andere vennootschap, maar dit doet via een derde vennootschap waarin zij aandeelhouder is.
                </p>

                <div style="border: 1px solid #ccc; padding: 10px; background-color: lightgrey">
                    <p><u>Voorbeeld</u></p>
                    De heer A is 100% onmiddellijk aandeelhouder in vennootschap B. Vennootschap B is 100% onmiddellijk
                    aandeelhouder in vennootschap C. De heer A is daarmee (voor 100%) middellijk aandeelhouder in
                    vennootschap C.
                </div>
                <br/>

                <b>Leden</b>
                <p>Leden kunnen geld in de coöperatie inbrengen via aparte ledenrekeningen. Dit ledenkapitaal is niet
                    verhandelbaar, in tegenstelling tot aandelen in een bv.</p>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading10">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse10" aria-expanded="false" aria-controls="collapse10">
                Earnout-regeling
            </button>
        </h2>
        <div id="collapse10" class="accordion-collapse collapse" aria-labelledby="heading10"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Als de vennootschap in het boekjaar een deelneming hebt verkregen of vervreemd tegen een prijs die
                    geheel of
                    gedeeltelijk bestaat uit een recht op 1 of meer termijnen waarvan het aantal of de omvang in het
                    jaar van de vervreemding nog niet vaststaat (earn-outregeling), vallen de volgende resultaten onder
                    de deelnemingsvrijstelling:</p>
                <ul style="list-style: disc;">
                    <li>voor de verkoper: waardeveranderingen van het recht op 1 of meer termijnen.</li>
                    <li>voor de koper: waardeveranderingen van de bijbehorende verplichting.</li>
                </ul>
                <p>Aanpassingen van de verkoopprijs (bijvoorbeeld de balansgarantie) vallen ook onder de
                    deelnemingsvrijstelling. Dit geldt ook voor de inkoop van aandelen.</p>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading11">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse11" aria-expanded="false" aria-controls="collapse11">
                Tegenbewijsregeling renteaftrek
            </button>
        </h2>
        <div id="collapse11" class="accordion-collapse collapse" aria-labelledby="heading11"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Rente, inclusief kosten en valutaresultaten, die is verschuldigd aan een verbonden lichaam of een
                    verbonden
                    natuurlijk persoon en die niet aftrekbaar is op grond van artikel 10a, lid 1 Vpb, is toch
                    aftrekbaar als je gebruikmaakt van 1 van de 2 tegenbewijsregelingen van artikel 10a, lid 3 Vpb:</p>
                <ul>
                    <li>Je kunt aannemelijk maken dat aan de schuld en aan de daarmee verband houdende rechtshandeling
                        in
                        overwegende mate zakelijke overwegingen ten grondslag liggen. Het maakt niet uit of die schuld
                        in feite is verschuldigd aan een ander dan een met de belastingplichtige verbonden lichaam of
                        met hem verbonden natuurlijk persoon.
                    </li>
                    <li>Je kunt aannemelijk maken dat over de rentebate bij de schuldeiser een belasting verschuldigd is
                        die naar Nederlandse maatstaven redelijk is (compenserende heffing). Dit is het geval bij een
                        heffing van ten minste 10% over een naar Nederlandse maatstaven bepaalde belastbare winst. De
                        schuldeiser mag geen aanspraken hebben op verrekening van verliezen, of andere aanspraken uit
                        vorige jaren waardoor hij alsnog geen belasting hoeft te betalen. Ook mag de lening niet zijn
                        aangegaan om verliezen of andere aanspraken bij de schuldeiser te verrekenen die in het jaar
                        zelf zijn ontstaan of binnenkort zullen ontstaan.
                    </li>
                </ul>
                <p>Het kan voorkomen dat de inspecteur aannemelijk maakt dat aan de schuld of de rechtshandeling niet
                    voor meer dan 50% zakelijke overwegingen ten grondslag liggen. In dat geval is de rente over de
                    schuld niet aftrekbaar.</p>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading12">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse12" aria-expanded="false" aria-controls="collapse12">
                Belang in fiscaal transparante entiteiten
            </button>
        </h2>
        <div id="collapse12" class="accordion-collapse collapse" aria-labelledby="heading12"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Fiscaal transparant betekent dat de entiteit zelf geen winstbelasting betaalt, maar dat de deelnemers
                    in de entiteit dit doen.
                </p>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading13">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse13" aria-expanded="false" aria-controls="collapse13">
                Afgezonderd vermogen in een APV
            </button>
        </h2>
        <div id="collapse13" class="accordion-collapse collapse" aria-labelledby="heading13"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Vermogen dat wordt ingebracht in een trust of (buitenlandse) stichting die een particulier doel
                    dient, kan worden aangemerkt als een afgezonderd particulier vermogen (APV). Het gaat hier vaak om
                    familievermogen.</p>
                <p>Een afgezonderd particulier vermogen (APV) wordt belast bij degene die het vermogen in het APV heeft
                    ondergebracht.</p>
                <b>Wat valt er onder een afgezonderd particulier vermogen?</b>
                <p>Onder een APV vallen bijvoorbeeld:</p>
                <ul>
                    <li>(family) trusts.</li>
                    <li>Antilliaanse Stichtingen Particulier Fonds (SPF).</li>
                    <li>(Private) Foundations.</li>
                    <li>Stiftungen en Anstalten in bijvoorbeeld Liechtenstein.</li>
                    <li>Nederlandse particuliere stichtingen.</li>
                </ul>
                <p>Een APV heeft vooral een particulier belang van bijvoorbeeld een familie. Gaat het om het algemeen
                    nut of een sociaal belang? Dan is er meestal geen sprake van een APV.</p>
            </div>
        </div>
    </div>
</div>


